import OAuthIntegrationDashboard from './views/OAuthIntegrationDashboard.vue';
const routes = [
  {
    name: 'oauth-integration-dashboard',
    path: '/advisor/integrations',
    component: OAuthIntegrationDashboard,
  },
];

export default routes;
